import * as Optional from "optional-js";

/**
 * This helper delegates an event of a Backbone.Events target to another one.
 * @param originator {Backbone.Events}
 * @param delegate {Backbone.Events}
 * @param event {string}
 */
export const delegateEvent = (originator, delegate, event) =>
    originator.on(event, (...data) =>
        Optional.ofNullable(delegate).ifPresent(d => d.trigger(event, ...data)));